import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { SocialIcon } from "@/components/SocialIcons";
import { SOCIALS } from "@/content";

const TINTS = {
  Instagram: "hover:border-mag/60 hover:shadow-[0_0_30px_rgba(255,0,85,0.18)] hover:text-mag",
  TikTok: "hover:border-cy/60 hover:shadow-[0_0_30px_rgba(0,240,255,0.18)] hover:text-cy",
  YouTube: "hover:border-mag/60 hover:shadow-[0_0_30px_rgba(255,0,85,0.18)] hover:text-mag",
  Facebook: "hover:border-cy/60 hover:shadow-[0_0_30px_rgba(0,240,255,0.18)] hover:text-cy",
  X: "hover:border-volt/60 hover:shadow-[0_0_30px_rgba(204,255,0,0.18)] hover:text-volt",
};

export default function Socials() {
  return (
    <section id="socials" data-testid="socials-section" className="relative py-20 lg:py-32">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(204,255,0,0.06),transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHead
          eyebrow="Socials"
          title={<>Follow The <span className="text-neon">Hype</span></>}
          sub="Daily drops, live clips and behind-the-scenes madness. Join the movement on every platform."
          align="center"
        />

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {SOCIALS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.08}>
              <a
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-card-${s.name.toLowerCase()}`}
                className={`group glass rounded-2xl p-6 flex flex-col items-center text-center gap-3 text-zinc-300 transition-all ${TINTS[s.name]}`}
              >
                <SocialIcon name={s.name} className="w-8 h-8" />
                <div>
                  <p className="font-head font-bold uppercase text-sm tracking-wide text-white">{s.name}</p>
                  <p className="font-mono text-[11px] tracking-[0.15em] text-zinc-500 mt-1">{s.handle}</p>
                </div>
                <p className="font-display font-700 text-xl text-white">
                  {s.followers}
                  <span className="block font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mt-1">
                    {s.metric || "Followers"}
                  </span>
                </p>
                <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 text-center">
          <a
            href={SOCIALS[0].url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="socials-follow-cta"
            className="inline-flex items-center gap-3 bg-volt text-ink font-head font-bold uppercase tracking-wider px-10 py-4 rounded-full shadow-[0_0_35px_rgba(204,255,0,0.35)] hover:shadow-[0_0_50px_rgba(204,255,0,0.55)] transition-shadow"
          >
            Follow @qt2hype
          </a>
        </Reveal>
      </div>
    </section>
  );
}
